import React from 'react'
import Image from 'next/image'
import Text from 'app/app/(client)/components/atoms/Text/Text'
import { Constants } from 'app/app/(client)/utils/client-constants'

interface NoDataProps {
  noDataText: string
  children?: React.ReactNode
}

const NoData: React.FC<NoDataProps> = ({ noDataText, children }) => (
  <div className="flex flex-col justify-center items-center mt-6">
    <Image src={Constants.NO_DATA_IMAGE} alt="No Data" width={473} height={400} />

    <Text id="no-shared-opportunity-text" as="div" className="text-center text-grey-outline text-16px font-normal mt-5">
      {noDataText}
    </Text>
    {children && <div className="mt-6">{children}</div>}
  </div>
)

export default NoData
